import React, { MutableRefObject } from "react";
import axios, { AxiosRequestConfig } from "axios";
import { Dispatch } from "redux";
import { LoginWithApp } from "./LoginWithApp";
import { GlobalError } from "../../../components/errors/GlobalError";
import { GetApplication, GetApplicationVersion } from "utilityFunctions";

export const LoginWithToken =
  (
    language: string,
    token: string,
    persistentLogin: boolean,
    stopLoginWithToken: MutableRefObject<boolean>,
    setRedirect: React.Dispatch<React.SetStateAction<boolean>>,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setShowRemoteAuthModal: React.Dispatch<React.SetStateAction<boolean>>
  ) =>
  async (dispatch: Dispatch<any>) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
  

    const loginWithTokenRequest = {application: await GetApplication(),
      applicationVersion: GetApplicationVersion(),
      token,
      waitForIt: false}
    
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": language === "en" ? "en-US;" : "fr-CA;",
      },
    };

    const client = axios.create({ baseURL: `${BASE_URL}/api/auth/loginWithToken`});

    client.interceptors.response.use(response => {
      return response;
    }, error => {
        const { config, response: { status }} = error;
        const originalRequest = config;
    
        if (!stopLoginWithToken.current && status === 401) {
          return sleepRequest(2000, originalRequest, error);
        } else {
          return Promise.reject(error);
        }
    });

    const sleepRequest = (milliseconds: number, originalRequest: AxiosRequestConfig, error: any) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
              if (!stopLoginWithToken.current) {
                resolve(client(originalRequest));
              } else {
                reject(error);
              }}, milliseconds);
        });
    };

    try {
      setLoading(true)
      const loginWithTokenResponse = await client.post(
        `${BASE_URL}/api/auth/loginWithToken`,
        loginWithTokenRequest,
        config
      );

      if (loginWithTokenResponse.status === 200) {
        const { accessToken, refreshToken } = loginWithTokenResponse.data;
        LoginWithApp(
          accessToken,
          refreshToken,
          persistentLogin,
          dispatch,
          setRedirect
        );
        setLoading(false)
        setShowRemoteAuthModal(false)
      }
    } catch (error: any) {
      setLoading(false)
      setShowRemoteAuthModal(false)
      if (error.response?.status !== 401) {
        console.log("there has been an error", error.response);
        GlobalError(error);
      }
    }
  };
